export const questionCountsAsAttempted = (row) =>
  row?.submitted === true || Number(row?.attempted) > 0;

export const withSubmittedProgress = (stats) => {
  if (!stats) return stats;
  const categories = { ...stats.categories };
  let extra = 0;
  for (const question of Object.values(stats.questions || {})) {
    if (!question?.submitted || Number(question.attempted) > 0) continue;
    extra++;
    if (question.category) {
      const category = categories[question.category] || {};
      categories[question.category] = {
        ...category,
        uniqueQuestionsAttempted: (category.uniqueQuestionsAttempted || 0) + 1,
      };
    }
  }
  return {
    ...stats,
    categories,
    uniqueQuestionsAttempted: (stats.uniqueQuestionsAttempted || 0) + extra,
  };
};

export const isCurrentProgressSession = (session, progress) =>
  (session?.progressGeneration || 0) === (progress?.generation || 0);

// Explicit undo wins for progress only. Marks remain available for scoring.
export const applyStationProgress = (seen, progress, validIds) => {
  const result = new Set(seen);
  for (const [id, state] of Object.entries(progress?.attempts || {})) {
    if (!validIds.has(id)) continue;
    if (state.attempted) result.add(id);
    else result.delete(id);
  }
  return result;
};

export const isResetSessionForOwner = (session, progress, uid) =>
  !!uid &&
  session?.userId === uid &&
  !isCurrentProgressSession(session, progress);
